<template>
    <div
        id="sidebar__contentId"
        class="sidebar__content">
        <div class="sidebar__box sidebar__box--desktop">
            <button
                type="button"
                data-sort-filter
                data-gtm="sidebar__sort--filter"
                data-pendo="sidebar__sort--filter"
                aria-label="Sort filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': sortFilterIsActive }"
                @click="toggleFilter('sort'); scrollFilterContent('sortFilter', '[data-sort-filter]', sortFilterIsActive);">
                {{ trans('SORT') }}
                <span class="sidebar__filterItem">
                    <span class="sidebar__filterSetting">
                        {{ sortValue }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': sortFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="sortFilterIsActive"
                ref="sortFilter"
                :class="{ sidebar__filterActive: sortFilterIsActive }">
                <SortFilter @selected-sort-config="emittedSortSelection" />
            </div>
        </div>
        <div class="sidebar__box">
            <button
                type="button"
                data-content-filter
                data-gtm="sidebar__contentType--filter"
                data-pendo="sidebar__contentType--filter"
                aria-label="Content type filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': contentTypeFilterIsActive }"
                @click="toggleFilter('contentType'); scrollFilterContent('contentFilter', '[data-content-filter]', contentTypeFilterIsActive);">
                {{ trans('CONTENT_TYPES') }}
                <span class="sidebar__filterItem">
                    <span
                        v-if="contentTypeValue.length > 0"
                        class="sidebar__filterSetting">
                        {{ contentTypeValue.length }}
                        <span v-if="contentTypeValue.length > 1">{{ trans('FILTER_SETTINGS_MULTIPLE') }}</span>
                        <span v-else> {{ trans('FILTER_SETTINGS') }}</span>
                    </span>
                    <span
                        v-else
                        class="sidebar__filterSetting">
                        {{ trans('STATISTIC_OPTIONS_DATAPOINTS_ALL') }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': contentTypeFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="contentTypeFilterIsActive"
                ref="contentFilter"
                :class="{ sidebar__filterActive: contentTypeFilterIsActive }">
                <ContentTypeFilter @selected-contentTypes="emittedContentTypeValue" />
            </div>
        </div>
        <div class="sidebar__box">
            <button
                type="button"
                data-accuracy-filter
                data-gtm="sidebar__accuracy--filter"
                data-pendo="sidebar__accuracy--filter"
                aria-label="Accuracy filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': accuracyFilterIsActive }"
                @click="toggleFilter('accuracy'); scrollFilterContent('accuracyFilter', '[data-accuracy-filter]', accuracyFilterIsActive);">
                {{ trans('ACCURACY') }}
                <span class="sidebar__filterItem">
                    <span class="sidebar__filterSetting">
                        {{ accuracyValue }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': accuracyFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="accuracyFilterIsActive"
                ref="accuracyFilter"
                :class="{ sidebar__filterActive: accuracyFilterIsActive }">
                <AccuracyFilter @selected-accuracy-text="emittedAccuracyValue" />
            </div>
        </div>

        <div class="sidebar__box">
            <button
                type="button"
                data-location-filter
                data-gtm="sidebar__location--filter"
                data-pendo="sidebar__location--filter"
                aria-label="Location filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': locationFilterIsActive }"
                @click="toggleFilter('location'); scrollFilterContent('locationFilter', '[data-location-filter]', locationFilterIsActive);">
                {{ trans('GLOBAL_LOCATION') }}
                <span class="sidebar__filterItem">
                    <span
                        v-if="countriesValue.length === 0"
                        class="sidebar__filterSetting">
                        {{ regionValue.label }}
                    </span>
                    <span
                        v-else
                        class="sidebar__filterSetting">
                        {{ countriesValue.length }}
                        <span v-if="countriesValue.length > 1">{{ trans('FILTER_SETTINGS_MULTIPLE') }}</span>
                        <span v-else> {{ trans('FILTER_SETTINGS') }}</span>
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': locationFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="locationFilterIsActive"
                ref="locationFilter"
                :class="{ sidebar__filterActive: locationFilterIsActive }">
                <LocationFilter
                    @selected-region="emittedRegionValue"
                    @selected-countries="emittedCountriesValue" />
            </div>
        </div>
        <div class="sidebar__box sidebar__box--desktop">
            <button
                type="button"
                data-regionalBoost-filter
                data-gtm="sidebar__regionalBoost--filter"
                data-pendo="sidebar__regionalBoost--filter"
                aria-label="Regional boost Filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': regionalBoostFilterIsActive }"
                @click="toggleFilter('regionalBoost'); scrollFilterContent('regionalBoostFilter', '[data-regionalBoost-filter]', regionalBoostFilterIsActive); ">
                {{ trans('FORM_SEARCH_REGION_FOCUS_MOBILE') }}
                <span class="sidebar__filterItem">
                    <span class="sidebar__filterSetting">
                        {{ regionalBoostName }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': regionalBoostFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="regionalBoostFilterIsActive"
                ref="regionalBoostFilter"
                :class="{ sidebar__filterActive: regionalBoostFilterIsActive }">
                <RegionalBoostFilter
                    :sort-selection="sortSelection"
                    @selected-regionalBoost="emittedRegionalBoostValue" />
            </div>
        </div>
        <div class="sidebar__box">
            <button
                type="button"
                data-industry-filter
                data-gtm="sidebar__industry--filter"
                data-pendo="sidebar__industry--filter"
                aria-label="Industry Filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': industryFilterIsActive }"
                @click="toggleFilter('industry'); scrollFilterContent('industryFilter', '[data-industry-filter]', industryFilterIsActive);">
                {{ trans('FORM_INDUSTRY') }}
                <span class="sidebar__filterItem">
                    <span>
                        <span
                            v-if="subCategoryValue.length > 0 && !subCategoryValue.includes(ALL_OPTIONS_SELECTED)"
                            class="sidebar__filterSetting">
                            {{ subCategoryValue.length }}
                            <span>{{ trans('FILTER_SETTINGS_MULTIPLE') }}</span>
                        </span>
                        <span
                            v-else
                            class="sidebar__filterSetting">
                            {{ trans('STATISTIC_OPTIONS_DATAPOINTS_ALL') }}
                        </span>
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': industryFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="industryFilterIsActive"
                ref="industryFilter"
                :class="{ sidebar__filterActive: industryFilterIsActive }">
                <IndustryFilter
                    :selected-categories-value="selectedCategoriesValue"
                    @selected-category="emittedCategoryValue"
                    @selected-sub-category="emittedSubCategoryValue" />
            </div>
        </div>

        <div class="sidebar__box">
            <button
                type="button"
                data-publication-filter
                data-gtm="sidebar__publicationDate--filter"
                data-pendo="sidebar__publicationDAte--filter"
                aria-label="Publication date filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': publicationDateFilterIsActive }"
                @click="toggleFilter('publicationDate'); scrollFilterContent('publicationFilter','[data-publication-filter]', publicationDateFilterIsActive);">
                {{ trans('FORM_FILTER_PUBLICATION_DATE') }}
                <span class="sidebar__filterItem">
                    <span
                        v-if="intervalValue[0] === ALL_OPTIONS_SELECTED || intervalValue.length === 0"
                        class="sidebar__filterSetting">
                        {{ trans('STATISTIC_OPTIONS_DATAPOINTS_ALL') }}
                    </span>
                    <span
                        v-else
                        class="sidebar__filterSetting">
                        {{ intervalValue.length }}
                        <span>{{ trans('FILTER_SETTINGS_MULTIPLE') }}</span>
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': publicationDateFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="publicationDateFilterIsActive"
                ref="publicationFilter"
                :class="{ sidebar__filterActive: publicationDateFilterIsActive }">
                <PublicationDateFilter @selected-interval="emittedIntervalValue" />
            </div>
        </div>

        <div class="sidebar__box">
            <button
                type="button"
                data-archive-filter
                data-gtm="sidebarFilter__archive--filter"
                data-pendo="sidebarFilter__archive--filter"
                aria-label="Archive filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': archiveFilterIsActive }"
                @click="toggleFilter('archive'); scrollFilterContent('archiveFilter', '[data-archive-filter]', archiveFilterIsActive);">
                {{ trans('FORM_SEARCH_ARCHIVE_LABEL') }}
                <span class="sidebar__filterItem">
                    <span class="sidebar__filterSetting">
                        {{ archiveValue }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': archiveFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="archiveFilterIsActive"
                ref="archiveFilter"
                :class="{ sidebar__filterActive: archiveFilterIsActive }">
                <ArchiveFilter @selected-archive-name="emittedArchiveValue" />
            </div>
        </div>

        <div
            v-if="currentLanguage !== 'en'"
            class="sidebar__box">
            <button
                type="button"
                data-language-filter
                data-gtm="sidebarFilter__language--filter"
                data-pendo="sidebarFilter__language--filter"
                aria-label="Language filter"
                class="sidebar__filter sidebar__filter--text"
                :class="{ 'sidebar__filter--active': languageFilterIsActive }"
                @click="toggleFilter('language'); scrollFilterContent('languageFilter', '[data-language-filter]', languageFilterIsActive);">
                {{ trans('FORM_SEARCH_LANGUAGE_LABEL') }}
                <span class="sidebar__filterItem">
                    <span class="sidebar__filterSetting">
                        {{ languageValue }}
                    </span>
                    <svg
                        height="16px"
                        width="16px"
                        :class="{ sidebar__icon: true, 'sidebar__icon--open': languageFilterIsActive }"
                        aria-hidden="true">
                        <use href="#iconChevronDownBold" />
                    </svg>
                </span>
            </button>
            <div
                v-show="languageFilterIsActive"
                ref="languageFilter"
                :class="{ sidebar__filterActive: languageFilterIsActive }">
                <LanguageFilter @selected-language-name="emittedLanguageValue" />
            </div>
        </div>
    </div>
</template>

<script>

    const LANGUAGE_ENGLISH = '2';

    import { computed } from 'vue';
    import { isMobile } from 'tools/isMobile';
    import { useGetters, useActions } from 'composables/useVuex';
    import ContentTypeFilter from './components/contentTypeFilter';
    import AccuracyFilter from './components/accuracyFilter';
    import LocationFilter from './components/locationFilter';
    import PublicationDateFilter from './components/publicationDateFilter';
    import ArchiveFilter from './components/archiveFilter';
    import IndustryFilter from './components/industryFilter';
    import LanguageFilter from './components/languageFilter';
    import SortFilter from './components/sortFilter';
    import RegionalBoostFilter from './components/regionalBoostFilter';
    import Translator from 'tools/trans';
    export default {
        name: 'SidebarFilter',
        components: {
            AccuracyFilter,
            ContentTypeFilter,
            LocationFilter,
            PublicationDateFilter,
            ArchiveFilter,
            IndustryFilter,
            SortFilter,
            RegionalBoostFilter,
            LanguageFilter,
        },
        props: {
            selectedCategoriesValue: { type: Object, default: () => {} },
        },
        data() {
            return {
                accuracyFilterIsActive: false,
                publicationDateFilterIsActive: false,
                contentTypeFilterIsActive: false,
                locationFilterIsActive: false,
                archiveFilterIsActive: false,
                industryFilterIsActive: false,
                sortFilterIsActive: false,
                regionalBoostFilterIsActive: false,
                languageFilterIsActive: false,
                contentTypeValue: this.getTabGroup,
                accuracyValue: '',
                countriesValue: [],
                intervalValue: [],
                changed: false,
                locationName: '',
                regionalBoostName: '',
                publicationName: '',
                archiveValue: '',
                categoryValue: this.category,
                subCategoryValue: this.subCategory,
                categoryName: '',
                regionValue: '',
                sortValue: '',
                sortSelection: '',
                regionalBoostValue: '',
                languageValue: '',
                isMobile: isMobile(),
                currentLanguage: window.stGlobals.locale,
                ALL_OPTIONS_SELECTED: '0',
                filterIsOpen: false,
            };
        },
        watch: {
            regionalBoostValue(value) {
                const regionalBoost = this.filterOptions.find((filterOption) => {
                    return filterOption.value === value;
                });
                if (regionalBoost) {
                    this.regionalBoostName = regionalBoost.name;
                }
            },
        },
        methods: {
            trans: Translator.trans,
            toggleFilter(filter) {
                this.filterIsOpen = !this.filterIsOpen;
                this.$emit('is-filter-open', this.filterIsOpen);
                if (filter === 'accuracy') {
                    this.accuracyFilterIsActive = !this.accuracyFilterIsActive;
                    this.contentTypeFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.publicationDateFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'contentType') {
                    this.contentTypeFilterIsActive = !this.contentTypeFilterIsActive;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.publicationDateFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'location') {
                    this.locationFilterIsActive = !this.locationFilterIsActive;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.publicationDateFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'publicationDate') {
                    this.publicationDateFilterIsActive = !this.publicationDateFilterIsActive;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'archive') {
                    this.archiveFilterIsActive = !this.archiveFilterIsActive;
                    this.publicationDateFilterIsActive = false;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'industry') {
                    this.industryFilterIsActive = !this.industryFilterIsActive;
                    this.publicationDateFilterIsActive = false;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'sort') {
                    this.sortFilterIsActive = !this.sortFilterIsActive;
                    this.publicationDateFilterIsActive = false;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'regionalBoost') {
                    this.regionalBoostFilterIsActive = !this.regionalBoostFilterIsActive;
                    this.publicationDateFilterIsActive = false;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.languageFilterIsActive = false;
                } else if (filter === 'language') {
                    this.languageFilterIsActive = !this.languageFilterIsActive;
                    this.publicationDateFilterIsActive = false;
                    this.contentTypeFilterIsActive = false;
                    this.accuracyFilterIsActive = false;
                    this.locationFilterIsActive = false;
                    this.industryFilterIsActive = false;
                    this.archiveFilterIsActive = false;
                    this.sortFilterIsActive = false;
                    this.regionalBoostFilterIsActive = false;
                }
                const isTabOpen = this.languageFilterIsActive || this.publicationDateFilterIsActive || this.contentTypeFilterIsActive ||
                    this.accuracyFilterIsActive || this.locationFilterIsActive || this.industryFilterIsActive || this.archiveFilterIsActive;
                this.setCurrentOpenTab(isTabOpen ? filter : null);
            },
            emittedContentTypeValue(filterValue) {
                this.contentTypeValue = filterValue;
            },
            emittedAccuracyValue(filterValue) {
                this.accuracyValue = filterValue;
            },
            emittedCountriesValue(filterValue) {
                this.countriesValue = filterValue;
            },
            emittedIntervalValue(filterValue) {
                this.intervalValue = filterValue;
            },
            emittedArchiveValue(filterValue) {
                this.archiveValue = filterValue;
            },
            emittedSortSelection(filterValue) {
                this.sortSelection = filterValue.param;
                this.sortValue = filterValue.value;
                this.$emit('selected-sort', filterValue.param);
            },
            emittedRegionalBoostValue(filterValue) {
                this.regionalBoostValue = filterValue;
            },
            emittedCategoryValue(filterValue) {
                this.categoryValue = filterValue;
            },
            emittedSubCategoryValue(filterValue) {
                this.subCategoryValue = filterValue;
            },
            emittedRegionValue(filterValue) {
                this.regionValue = filterValue;
            },
            emittedLanguageValue(filterValue) {
                this.languageValue = filterValue;
            },
            scrollFilterContent(filter, dataTagValue, isActive) {
                const dataTag = document.querySelector(dataTagValue);
                const options = { threshold: 1 };
                if (this.isMobile){
                    const observer = new IntersectionObserver(
                        ([event]) => {
                            if (!event.isIntersecting) {
                                dataTag.scrollIntoView(true);
                            }
                            observer.unobserve(this.$refs[filter]);
                        }, options,
                    );
                    observer.observe(this.$refs[filter]);

                    return;
                }
                if (!isActive) {
                    return;
                }
                const observer = new IntersectionObserver(
                    ([event]) => {
                        if (!event.isIntersecting) {
                            window.scrollTo({ top: dataTag.offsetTop, behavior: 'smooth' });
                        }
                        observer.unobserve(this.$refs[filter]);
                    }, options,
                );
                observer.observe(this.$refs[filter]);
            },
        },
        mounted() {
            this.ALL_OPTIONS_SELECTED = '0';
            this.contentFilters = this.getTabGroup;
            this.setSubCategories();
            this.subCategoryValue = this.subCategory;
            this.regionValue = this.isoregionsData.find((regionOption) => {
                return regionOption.value === this.isoregion;
            });
            const regionalBoost = this.filterOptions.find((filterOption) => {
                return filterOption.value === this.focus;
            });
            if (regionalBoost) {
                this.regionalBoostName = regionalBoost.name;
            }
            const branchPosition = this.branchesData.find((branchOption) => {
                return branchOption.value === this.category;
            });
            if (branchPosition) {
                this.categoryName = branchPosition.label;
            }
            if (this.accuracy === 'or') {
                this.accuracyValue = this.trans('EXTENDED_SEARCH_ACCURACY_FILTER_ANY');
            } else {
                this.accuracyValue = this.trans('EXTENDED_SEARCH_ACCURACY_FILTER_ALL');
            }
            if (this.idRelevance === '-1') {
                this.archiveValue = this.trans('EXTENDED_SEARCH_ARCHIVE_FILTER_INCLUSIVE');
            } else {
                this.archiveValue = this.trans('EXTENDED_SEARCH_ARCHIVE_FILTER_NO');
            }
            if (Number(this.language) === Number(this.ALL_OPTIONS_SELECTED)) {
                this.languageValue = this.trans('EXTENDED_SEARCH_LANGUAGE_ALL');
            } else if (this.language === LANGUAGE_ENGLISH){
                this.languageValue = this.trans('EXTENDED_SEARCH_ONLY_ENGLISH');
            } else {
                this.languageValue = this.trans('EXTENDED_SEARCH_ONLY_LOCALE');
            }
            /*if (this.sort === 'popularity') {
                this.sortValue = this.trans('FORM_SEARCH_POPULARITY');
            } else*/ if (this.sort === 'publicationDate') {
                this.sortValue = this.trans('FORM_SEARCH_DATE');
            } else {
                this.sortValue = this.trans('FORM_SEARCH_RELEVANCE');
            }
            this.intervalValue = this.interval;
            if (this.activeTab) {
                this.toggleFilter(this.activeTab);
            }
        },
        setup() {
            const filterOption = computed(() => {
                      return getters.focus.value || '-1';
                  }),
                  filterOptions = computed(() => {
                      return getters.countries.value.map(item => {
                          return {
                              value: item.value,
                              name: Translator.trans(item.label),
                          };
                      });
                  });
            const getters = {
                ...useGetters('search', [
                    'intervalData',
                    'interval',
                    'getTabGroup',
                    'accuracy',
                    'idRelevance',
                    'category',
                    'countries',
                    'subCategory',
                    'branchesData',
                    'isoregion',
                    'isoregionsData',
                    'sort',
                    'focus',
                    'getInterval',
                    'language',
                    'activeTab',
                ]),
            };
            const actions = {
                ...useActions('search', [
                    'setSubCategoryInitial',
                    'setActiveTab',
                ]),
            };
            async function setSubCategories() {
                await actions.setSubCategoryInitial();
            }
            async function setCurrentOpenTab(currentTab) {
                await actions.setActiveTab(currentTab);
            }

            return {
                filterOption,
                filterOptions,
                setSubCategories,
                setCurrentOpenTab,
                ...getters,
            };
        },
    };
</script>

